export enum CampaignImageType {
  Banner = 'banner',
  Main = 'main',
}

export type CampaignImageDto = {
  id: number;
  type: CampaignImageType;
  url: string;
};

export type initState = {
  images: CampaignImageDto[];
};
